if (!customElements.get('product-promo-offer')) {
  class ProductPromoOffer extends HTMLElement {
    constructor() {
      super();
      this.cartDrawer = document.querySelector('cart-drawer');
      this.mainID = new Date().getTime();
      this.offers = this.querySelectorAll('[data-promo-offer]');
      this.productFormArr = this.closest('product-info').querySelectorAll('product-form')
      this.promoOfferData = JSON.parse(this.querySelector('[data-promo-offer-data]').dataset.promoOfferData);

      // helper
      this.helper = this.dataset.prodHelper;
      let letMeTrough = false;

      if (window[this.helper]) {
        letMeTrough = true;
      } else {
        if (window.productPromoOfferAb) {
          if (window.productPromoOfferAbIg) {
            letMeTrough = true;
          }
        } else {
          letMeTrough = true;
        }
      }

      // new tagging system
      this.theForm = this.productFormArr[0].querySelector('form');

      if (letMeTrough) {
        this.initStart();
      }

    }

    initStart() {

      let secondary_atc_label = this.promoOfferData.secondary_atc_label;
      let secondary_atc_scroll = this.promoOfferData.secondary_atc_scroll;

      // clone atc button
      this.atcButton = this.productFormArr[0].querySelector('.product-form__buttons button[type="submit"]');
      this.cloneButton = document.createElement("div");
      this.cloneButton.classList.add('button', 'button--lg', 'button--funnel', 'button--full-width', 'uppercase', 'min-h-[58px]', 'hidden', 'help-me-find');
      this.cloneButton.innerHTML = this.atcButton.innerHTML;
      this.productFormArr[0].querySelector('.product-form__buttons').append(this.cloneButton);

      this.cloneButton2 = document.createElement("div");
      this.cloneButton2.classList.add('button', 'button--lg', 'button--funnel', 'button--full-width', 'uppercase', 'min-h-[48px]', 'hidden', 'help-me-find');
      
      this.cloneButton2.innerHTML = this.atcButton.innerHTML;
      if (secondary_atc_label) {
        this.cloneButton2.innerHTML = secondary_atc_label;
      }

      this.secondaryAtc = this.productFormArr[1].querySelector('.button--funnel');
      this.productFormArr[1].querySelector('.form').append(this.cloneButton2);

      this.cloneButton.addEventListener('click', (e) => {
        this.addSet();
      });
      this.cloneButton2.addEventListener('click', (e) => {
        if (secondary_atc_scroll) {
          this.cloneButton.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
        } else {
          this.addSet();
        }
      });

      let that = this;
      this.offers.forEach((offer) => {
        offer.addEventListener('click', (e) => {
          let target = e.target;
          if (e.target.dataset) {
            if (e.target.dataset.promoOffer) {
              target = e.target;
            } else {
              target = e.target.closest('[data-promo-offer]');
            }
          } else {
            target = e.target.closest('[data-promo-offer]');
          }
          that.querySelector('[data-promo-offer].active').classList.remove('active');
          target.classList.add('active');
          if (target.dataset.promoOfferData) {
            if (document.querySelector('[data-promo-dynamic]') && document.querySelector('[data-promo-dynamic-2]')) {
              document.querySelector('[data-promo-dynamic]').classList.remove('hidden');
              document.querySelector('[data-promo-dynamic-2]').classList.add('hidden');
            }
            this.promoOfferData = JSON.parse(target.dataset.promoOfferData);
            this.addBundle();
          } else {
            if (document.querySelector('[data-promo-dynamic]') && document.querySelector('[data-promo-dynamic-2]')) {
              document.querySelector('[data-promo-dynamic-2]').classList.remove('hidden');
              document.querySelector('[data-promo-dynamic]').classList.add('hidden');
            }
            this.addSingle();
          }
        });
      });

      if (this.querySelector('[data-promo-offer].active').dataset) {
        if (this.querySelector('[data-promo-offer].active').dataset.promoOfferData) {
          this.atcButton.classList.add('hidden');
          this.cloneButton.classList.remove('hidden');
          this.secondaryAtc.classList.add('hidden');
          this.cloneButton2.classList.remove('hidden');
          this.promoOfferData = JSON.parse(this.querySelector('[data-promo-offer].active').dataset.promoOfferData);
        }
      }

      document.querySelectorAll('.notify-me').forEach((notify) => {
        notify.addEventListener('click', (e) => {
          document.querySelector('.help-me-find').click();
        });
      });
    }

    addSet() {
      this.mainID = new Date().getTime();
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
  
      const sectionsToFetch  = [
        ...this.cartDrawer.getSectionsToRender().map((section) => section.id),
      ];
  
      let items = [];
      let object = {};

      let image = this.promoOfferData.bundleImage;
      let name = this.promoOfferData.bundleName;
      let standardPrice = this.promoOfferData.standardPrice;
      let bundlePrice = this.promoOfferData.bundlePrice;
      let variantID = this.promoOfferData.bundleId;
      let giftId = this.promoOfferData.giftVariant_id;
      let giftSeperate = this.promoOfferData.giftSeperate;
      let variant = this.promoOfferData.variant;
      let variant_option = 'variant_a';
      if (variant == 'true') {
        variant_option = 'variant_b';
      }
      let giftGuard = this.promoOfferData.giftGuard;
      let shipping = this.promoOfferData.shipping;
      let shippingId = this.promoOfferData.shippingVariantId;
      let shippingSeparetly = this.promoOfferData.shippingSeparetly;
      let shippingGuard = this.promoOfferData.shippingGuard;
      let productId = this.promoOfferData.productVariant;
      productId = JSON.parse(this.querySelector('[data-promo-offer-data]').dataset.promoOfferData).productVariant;
      let itemQuantity = 1;
      let discount = '0';
      let quantity = this.promoOfferData.quantity;
      let combination = '';
      let selling_plan = parseInt(this.promoOfferData.gift_sub);
      let theDiscount = {
        "discount":"true",
        "amount": ((standardPrice- bundlePrice) / 100),
        "type":"fixed_amount",
        "label":"BUNDLE DISCOUNT",
        "combination":"",
        "cart_totals": 0
      };
      let theGiftDiscount = ((standardPrice - bundlePrice) / 100) * itemQuantity;
      let giftDiscount = {
        "discount":"true",
        "amount": theGiftDiscount,
        "type":"fixed_amount",
        "label":"BUNDLE DISCOUNT",
        "combination":"",
        "cart_totals": 0
      };
      if (giftGuard.length > 0) {
        combination = giftGuard + ':1'
        giftDiscount = {
          "discount":"true",
          "amount": theGiftDiscount,
          "type":"fixed_amount",
          "label":"BUNDLE DISCOUNT",
          "combination": combination,
          "cart_totals": 0
        };
      }
      let shippingDiscount = {
        "discount":"true",
        "amount": 100,
        "type":"percent",
        "label":"BUNDLE DISCOUNT",
        "combination":"",
        "cart_totals": 0
      };
      if (shippingGuard.length > 0) {
        combination = shippingGuard + ':1'
        giftDiscount = {
          "discount":"true",
          "amount": 100,
          "type":"percent",
          "label":"BUNDLE DISCOUNT",
          "combination":combination,
          "cart_totals": 0
        };
      }

      this.newTag = '';
      if (this.theForm.querySelector('[name="properties[_new_tagging]"]')) {
        this.newTag = this.theForm.querySelector('[name="properties[_new_tagging]"]').value;
      }
      if (this.newTag != '') {
        this.helper = '';
      }
      this.newTagGift = '';
      if (this.theForm.querySelector('[name="properties[_new_tag_gift]"]')) {
        this.newTagGift = this.theForm.querySelector('[name="properties[_new_tag_gift]"]').value;
      }
      this.newTagTag = '';
      if (this.theForm.querySelector('[name="properties[_new_tag_tag]"]')) {
        this.newTagTag = this.theForm.querySelector('[name="properties[_new_tag_tag]"]').value;
      }
      this.newTagQ = '';
      if (this.theForm.querySelector('[name="properties[_new_tag_q]"]')) {
        this.newTagQ = this.theForm.querySelector('[name="properties[_new_tag_q]"]').value;
      }
      this.newTagSub = '';
      if (this.theForm.querySelector('[name="properties[_new_tag_sub]"]')) {
        this.newTagSub = this.theForm.querySelector('[name="properties[_new_tag_sub]"]').value;
      }
      this.newTagPromo = '';
      if (this.theForm.querySelector('[name="properties[_new_tag_promo]"]')) {
        this.newTagPromo = this.theForm.querySelector('[name="properties[_new_tag_promo]"]').value;
      }
      this.newTagFt = '';
      if (this.theForm.querySelector('[name="properties[_new_tag_ft]"]')) {
        this.newTagFt = this.theForm.querySelector('[name="properties[_new_tag_ft]"]').value;
      }

      let currentDiscount = document.querySelector('[data-main-product-content] [data-prime-discounts-property]').value;

      // add main product
      if (giftSeperate) {
        object = {
          quantity: parseInt(quantity),
          id: parseInt(productId),
          properties: {
            "_parser": true,
            "_variant": variant_option,
            "_discount": currentDiscount,
            "_promo": this.helper,
            "_new_tagging": this.newTag,
            "_new_tag_tag": this.newTagTag,
            "_new_tag_gift": this.newTagGift,
            "_new_tag_q": this.newTagQ,
            "_new_tag_sub": this.newTagSub,
            "_new_tag_promo": this.newTagPromo,
            "_new_tag_ft": this.newTagFt,
            "_funnel": 'PDP',
            "_funnel_location": 'PROMO ATC',
            "_funnel_type": 'automatic'
          },
          selling_plan
        }
      } else {
        object = {
          quantity: parseInt(quantity),
          id: parseInt(productId),
          properties: {
            "product_bundle": 'Bundle-' + this.mainID,
            "_product_bundle_discount": discount,
            "_product_bundle_image": image,
            "_product_bundle_name": name,
            "_product_bundle_variant_id": variantID,
            "_discount": currentDiscount,
            "_funnel": 'PDP',
            "_funnel_location": 'PROMO ATC',
            "_funnel_type": 'manual'
          }
        }
      }
      items.push(object);

      // add gift
      object = {};
      if (giftSeperate) {
        object = {
          quantity: parseInt('1'),
          id: parseInt(giftId),
          properties: {
            "_discount": JSON.stringify(giftDiscount),
            "_free_product_notice": true,
            "_funnel": 'PDP',
            "_funnel_location": 'PROMO ATC',
            "_funnel_type": 'automatic'
          }
        }
      } else {
        object = {
          quantity: parseInt('1'),
          id: parseInt(giftId),
          properties: {
            "product_bundle": 'Bundle-' + this.mainID,
            "_product_bundle_discount": discount,
            "_product_bundle_image": image,
            "_product_bundle_name": name,
            "_product_bundle_variant_id": variantID,
            "_discount": JSON.stringify(theDiscount),
            "_funnel": 'PDP',
            "_funnel_location": 'PROMO ATC',
            "_funnel_type": 'manual'
          }
        }
      }
      items.push(object);

      // add free shipping
      if (shipping) {
        if (shippingId.length > 1) {
          object = {};
          if (shippingSeparetly) {
            object = {
              quantity: parseInt('1'),
              id: parseInt(shippingId),
              properties: {
                "_discount": JSON.stringify(shippingDiscount),
                "_funnel": 'PDP',
                "_funnel_location": 'PROMO ATC',
                "_funnel_type": 'automatic'
              }
            }
          } else {
            object = {
              quantity: parseInt('1'),
              id: parseInt(shippingId),
              properties: {
                "product_bundle": 'Bundle-' + this.mainID,
                "_product_bundle_discount": discount,
                "_product_bundle_image": image,
                "_product_bundle_name": name,
                "_product_bundle_variant_id": variantID,
                "_discount": JSON.stringify(theDiscount),
                "_funnel": 'PDP',
                "_funnel_location": 'PROMO ATC',
                "_funnel_type": 'manual'
              }
            }
          }
          
          items.push(object);
        }
      }

      let body = JSON.stringify({
        items: items,
        sections: sectionsToFetch,
        sections_url: window.location.pathname
      });
  
      fetch(`${routes.cart_add_url}`, {...fetchConfig(), ...{ body }})
        .then((response) => response.json())
        .then((parsedState) => {
          if (this.cartDrawer) {
            this.cartDrawer.renderContents(parsedState);
          }
          
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.cartDrawer.open();
          this.set = [];
        });

    }

    addBundle() {
      this.atcButton.classList.add('hidden');
      this.secondaryAtc.classList.add('hidden');
      document.querySelectorAll('.help-me-find').forEach((button) => {
        button.classList.remove('hidden');
      });
    }

    addSingle() {
      document.querySelectorAll('.help-me-find').forEach((button) => {
        button.classList.add('hidden');
      });
      this.atcButton.classList.remove('hidden');
      this.secondaryAtc.classList.remove('hidden');
    }
  }

  window.ProductPromoOffer = ProductPromoOffer;
  customElements.define('product-promo-offer', ProductPromoOffer);
}
